module.exports = __webpack_public_path__ + "static/media/collection-bird-04.340c372c.png";